import React from "react";
import { StateSelect } from "react-country-state-city";

const StateInput = ({ countryId, placeholder, error, onChange }) => (
  <div className="form-group">
    <StateSelect
      countryid={countryId}
      containerClassName={`form-control state ${error ? "error-field" : ""}`}
      inputClassName=""
      autoComplete="nope"
      placeHolder={placeholder}
      onChange={onChange}
    />
    {error && (
      <span className="error">{error}</span>
    )}
  </div>
);

export default StateInput;
